import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function PaymentResult({ type }) {
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const isSuccess = type === "success";

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6" data-testid={`payment-${type}-page`}>
      <div className="max-w-lg text-center border border-white/10 bg-coal p-12 md:p-16">
        {isSuccess ? (
          <>
            <CheckCircle2 size={48} className="text-ember mx-auto mb-8" />
            <h1 className="font-display text-4xl font-bold uppercase mb-4" data-testid="payment-success-title">
              {t.payment.successTitle}
            </h1>
            <p className="text-white/60 mb-10 leading-relaxed">{t.payment.successText}</p>
            <button
              data-testid="payment-back-btn"
              onClick={() => navigate("/")}
              className="bg-ember text-black text-xs uppercase tracking-[0.2em] font-bold rounded-full px-10 py-4 hover:bg-white transition-colors duration-300"
            >
              {t.payment.back}
            </button>
          </>
        ) : (
          <>
            <XCircle size={48} className="text-white/40 mx-auto mb-8" />
            <h1 className="font-display text-4xl font-bold uppercase mb-4" data-testid="payment-cancel-title">
              {t.payment.cancelTitle}
            </h1>
            <p className="text-white/60 mb-10 leading-relaxed">{t.payment.cancelText}</p>
            <button
              data-testid="payment-retry-btn"
              onClick={() => navigate("/donar")}
              className="bg-ember text-black text-xs uppercase tracking-[0.2em] font-bold rounded-full px-10 py-4 hover:bg-white transition-colors duration-300"
            >
              {t.payment.retry}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
